
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, ref, computed } from "vue";
export default defineComponent({
  name: "ShoppingListSearchInputView",
  props: {
    /**
     * 検索キーワード
     */
    inputText: {
      type: String,
      required: false
    },
    /**
     * フォーカス有効
     */
    isValidFocus: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const keyword = ref(props.inputText);
    const textInput = ref<HTMLInputElement>();
    NativeClient.sendDebugLog("ShoppingListSearchInputView setup Focus = " + props.isValidFocus);

    /**
     * 検索キーワードを取得、設定する
     */
    const keywordComputed = computed({
      get: () => keyword.value,
      set: value => (keyword.value = value)
    });
    /**
     * タグ押下を通知する
     */
    const setSearchedText = () => {
      NativeClient.sendDebugLog("ShoppingListSearchInputView set-searchword text = " + keywordComputed.value);
      context.emit("set-searchword", keywordComputed.value);
    };
    /** 
     * ボタンのテキスト
     */
    const searchButtonText = "検索";

    /**
     * 入力位置のフォーカス
     */
     const setFocusKeyword = () => {
      if (props.isValidFocus) {
        NativeClient.sendDebugLog("ShoppingListSearchInputView set-focus valid");
        context.emit("set-focus");
      }
    };

    /** 
     * 「検索」ボタン表示
     */
    const isValidSearchButton = computed(() => {
      NativeClient.sendDebugLog("ShoppingListSearchInputView isValidSearchButton = " + !props.isValidFocus);
      return !props.isValidFocus;
    });

    const handleEnter = () => {
      if (textInput.value != undefined) {
        textInput.value.blur();
      }
    };
    return {
      keywordComputed,
      setSearchedText,
      searchButtonText,
      setFocusKeyword,
      isValidSearchButton,
      textInput,
      handleEnter
    };
  }
});
